import React, { useState } from 'react'
import { Input } from 'antd';
import { Row, Col, Button } from 'antd'
import { withCookies, Cookies } from 'react-cookie';
import { Register } from '../api/api'
import { openNotification } from './utils';
import { useCookies } from 'react-cookie';

const LoginForm = () => {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confirmedPassword, setConfirmedPassword] = useState("")
    const [setCookie] = useCookies(['name']);

    const handleRegister = async () => {
        if(password != confirmedPassword) {
            openNotification({type: false, msg: 'Please confirm Password!'})
        } else {
            const queryData = {email, password}
            const resp = await Register(queryData)
            const { data } = resp
            openNotification(data)
            if(data.result) {
                setCookie('JWTToken', data.JWTToken)
                setCookie('email', email)
            }
            window.location.reload()
        }
        
    } 

    return <>
            <Row style={{margin: 16}} gutter={20}>
                <Col span={4}>Email: </Col>
                <Col span={20}>
                    <Input value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
                </Col>
            </Row>
            <Row style={{margin: 16}} gutter={20}>
                <Col span={4}>Password: </Col>
                <Col span={20}>
                    <Input type="password" value={password} onChange={(e)=>{setPassword(e.target.value)}}/>
                </Col>
            </Row>
            <Row style={{margin: 16}} gutter={20}>
                <Col span={4}>Confirm: </Col>
                <Col span={20}>
                    <Input type="password" value={confirmedPassword} onChange={(e)=>{setConfirmedPassword(e.target.value)}}/>
                </Col>
            </Row>
            <Row style={{margin: 16}} gutter={20}>
                <Col span={24}>            
                    <Button type='primary' style={{width: '100%'}} onClick={handleRegister}>Register</Button>
                </Col>
            </Row>
        </>
}

export default withCookies(LoginForm)
